import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import { useIntl } from 'react-intl';
import messages from '../../lib/messages.json';
import Head from '../Head';

const marketplaceHeadPropertyTypes = {
  title: PropTypes.string.isRequired,
};

type MarketplaceHeadProperties = InferProps<
  typeof marketplaceHeadPropertyTypes
>;

const MarketplaceHead = ({ title }: MarketplaceHeadProperties) => {
  const intl = useIntl();
  return (
    <Head
      title={title}
      description={
        intl.formatMessage(messages['markets.description'])
      }
    />
  );
};

MarketplaceHead.propTypes = marketplaceHeadPropertyTypes;

export default MarketplaceHead;
